import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Menu from "@mui/material/Menu";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

// Soft UI Dashboard PRO React example components
import BaseNavbarLink from "../BaseNavbar/BaseNavbarLink";

// BaseNavbar dropdown menu
import MenuOptions from "./MenuOptions";
import { matchPath, useLocation } from "react-router-dom";
import { useSoftUIController } from "hooks/context";

function BaseNavbarMobile({ routes, menuItems, open, close }) {
  const [openCollapse, setOpenCollapse] = useState(false);
  const location = useLocation();
  const [controller] = useSoftUIController();
  const { deviceLayout, userPermissions = [], appearance } = controller; // Extracted userPermissions context

  const handleSepOpenCollapse = (name) => openCollapse === name ? setOpenCollapse(false) : setOpenCollapse(name);

  function menuFilter(route, menuType) {
    if (route.key == 'settings' && menuType == 'settings') return true;
    if (!route.in_menu || !route.key.includes(menuType)) return false;

    // Look-ahead verification for collapsible structural nodes on mobile
    if (route.collapse && route.collapse.length > 0) {
      return route.collapse.some(child => userPermissions.includes(child.key));
    }
    return userPermissions.includes(route.key);
  }

  useEffect(() => {
    close();
  }, [location.pathname]);

  return (
    <Menu
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      anchorEl={open}
      open={Boolean(open)}
      onClose={close}
      MenuListProps={{ style: { width: `calc(100svw - 3rem)` } }}
    >
      <SoftBox px={0.5}>
        {menuItems.map((menuItem, itemIndex) => {
          var isSelected = location.pathname.startsWith(routes.filter(r => menuFilter(r, menuItem))?.[0]?.route) || routes.find(r => menuFilter(r, menuItem))?.collapse?.find(r => matchPath({ path: r.route }, location.pathname))?.name || false;

          return (
            <BaseNavbarLink
              key={itemIndex}
              name={menuItem}
              routes={routes.filter(r => menuFilter(r, menuItem))}
              collapseStatus={openCollapse === menuItem}
              closeHandler={close}
              onClick={() => handleSepOpenCollapse(menuItem)}
              appearance={appearance}
              isSelected={isSelected}
              deviceLayout={deviceLayout}
            >
              <SoftBox maxHeight="16rem" overflow="auto">
                <MenuOptions
                  routes={routes.filter(r => menuFilter(r, menuItem))}
                  route_path={menuItem}
                  close={close}
                  noCollapse={routes.filter(r => r.key == menuItem && !r.collapse).length > 0}
                  mobileMenu
                />
              </SoftBox>
            </BaseNavbarLink>
          );
        })}
      </SoftBox>
    </Menu>
  );
}

// Typechecking props for the DefaultNavbarMenu
BaseNavbarMobile.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  menuItems: PropTypes.array.isRequired,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
};

export default BaseNavbarMobile;